import { enqueueSnackbar, OptionsObject } from 'notistack'
import type { SxProps, Theme } from '@mui/material/styles'

export interface AdditionalAction {
  label: string
  onClick: () => void
}

export interface ExtraOptions extends OptionsObject {
  additionalAction?: AdditionalAction
  showCancel?: boolean
  details?: string
  alertSx?: SxProps<Theme>
}

type Props = {
  text: string
  options: ExtraOptions
}

export const showSnackbarNotification = (props: Props) => {
  const { text, options } = props

  enqueueSnackbar(text, options)
}
